import { nanoid } from "nanoid";

const services = [
    {
        id: nanoid(),
        name: "Usługa 1",
        isNew: true,
    },
    {
        id: nanoid(),
        name: "Usługa 2",
        isNew: false,
    },
    {
        id: nanoid(),
        name: "Usługa 3",
        isNew: false,
    },
    {
        id: nanoid(),
        name: "Usługa 4",
        isNew: false,
    },
    {
        id: nanoid(),
        name: "Usługa 5",
        isNew: false,
    },
    {
        id: nanoid(),
        name: "Usługa 6",
        isNew: false,
    },
]

export default services

